// =============================================================================
// Solmart quantity stepper.
// =============================================================================
// Global +/- buttons for [data-sol-stepper] wrappers (single-product cart
// row). Adjusts the wrapped input[name="quantity"] within its min/max bounds;
// delegated so it also works on markup swapped in later.
// =============================================================================

export default function initQtyStepper() {
	document.addEventListener("click", (event) => {
		const btn = event.target.closest("[data-sol-step]");
		if (!btn) {
			return;
		}
		const wrap = btn.closest("[data-sol-stepper]");
		const input = wrap && wrap.querySelector('input[name="quantity"]');
		if (!input) {
			return;
		}

		const min = Number.isFinite(parseFloat(input.min)) ? parseFloat(input.min) : 1;
		const max = input.max !== "" && Number.isFinite(parseFloat(input.max)) ? parseFloat(input.max) : Infinity;
		const current = parseInt(input.value, 10);
		const next = (Number.isNaN(current) ? min : current) + parseInt(btn.dataset.solStep, 10);

		input.value = String(Math.min(Math.max(next, min), max));
	});
}
